import { render } from "./MaterialCheckbox.vue?vue&type=template&id=04fa496a&scoped=true"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js"

import "./MaterialCheckbox.vue?vue&type=style&index=0&id=04fa496a&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04fa496a"]])

export default __exports__